import { AuthRouteTables } from "../../types/types";

export const ADMIN_NAV_SECTIONS = [
  { text: "Joukkueet", url: AuthRouteTables.TEAMS },
  { text: "Matsit", url: AuthRouteTables.MATCHES },
  { text: "Henkilökunta", url: AuthRouteTables.STAFF },
  { text: "Pelaajat", url: AuthRouteTables.PLAYERS },
  { text: "Tunnistamattomat", url: AuthRouteTables.PENDING },
  { text: "Liikenne", url: AuthRouteTables.TRAFFIC },
] as const;

export const getAdminSectionFromPath = (pathname: string) => {
  const segment = pathname.replace(/^\/admin\/?/, "").split("/")[0] || "";
  return ADMIN_NAV_SECTIONS.find((section) => section.url === segment);
};
